import React, {Component} from "react";

export default class AddBoardField extends Component{
    state = {}

    handleInputChange(event) {
        this.setState({fieldInput: event.target.value});
    }

    addFieldKey(){
        if(this.state.field && this.state.field.length > 0){
            let board = this.props.board;
            board.fields[this.state.field] = "";
            this.props.updateBoard(board);
            this.setState({field:""})
        }
    }
    render(){
        return <tr className={"border-0"}>
            <th className={"p-0"}>
                <input
                    onBlur={()=>this.addFieldKey()}
                    onChange={(ev)=>this.setState({field: ev.target.value})}
                    type="text"
                    value={this.state.field} placeholder={"+ New Field"}/>
            </th>
            <td>

            </td>
        </tr>
    }
}
